import { useEffect, useState } from 'react';

const NAV_LINKS = [
  { label: '核心功能', href: '#features' },
  { label: '省流指南', href: '#guide' },
  { label: '流量对比', href: '#compare' },
  { label: '常见问题', href: '#faq' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed left-0 right-0 top-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? 'border-b border-background-200 bg-background-50/95 backdrop-blur'
          : 'bg-transparent'
      }`}
    >
      <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:h-20 md:px-6">
        <a href="#top" className="flex items-center gap-2.5">
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-xl md:h-10 md:w-10 ${
              scrolled || open ? 'bg-primary-500' : 'bg-primary-500'
            }`}
          >
            <i className="ri-ink-bottle-line text-xl text-background-50"></i>
          </span>
          <span
            className={`font-heading text-lg md:text-xl ${
              scrolled || open ? 'text-foreground-900' : 'text-background-50'
            }`}
          >
            漫画人极速版
          </span>
        </a>

        <div className="hidden items-center gap-8 md:flex">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className={`text-sm font-medium transition-colors ${
                scrolled ? 'text-foreground-700 hover:text-primary-600' : 'text-background-100/90 hover:text-background-50'
              }`}
            >
              {link.label}
            </a>
          ))}
        </div>

        <div className="hidden items-center gap-3 md:flex">
          <a
            href="#download"
            className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            立即体验省流
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label="切换菜单"
          className="flex h-10 w-10 items-center justify-center md:hidden"
        >
          <i
            className={`${open ? 'ri-close-line' : 'ri-menu-line'} text-2xl ${
              scrolled || open ? 'text-foreground-900' : 'text-background-50'
            }`}
          ></i>
        </button>
      </nav>

      {open && (
        <div className="flex flex-col gap-1 border-t border-background-200 bg-background-50 px-4 py-4 md:hidden">
          {NAV_LINKS.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setOpen(false)}
              className="rounded-md px-3 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100"
            >
              {link.label}
            </a>
          ))}
          <a
            href="#download"
            onClick={() => setOpen(false)}
            className="whitespace-nowrap rounded-md bg-primary-500 px-3 py-2.5 text-center text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            立即体验省流
          </a>
        </div>
      )}
    </header>
  );
}